import ExportPDFButton from "./OnDemandPDFExport.jsx";
export default function Export(props){return <ExportPDFButton {...props} kind="sellreturn"/>;}
